import { TextField, Autocomplete } from "@mui/material";
const AutoCompleteMultiple = (props: any) => {
  const {
    style,
    onBlur,
    pageOption,
    touched,
    onchange,
    setFieldValue,
    disable,
    onchangeValue,
    notRequire,
    label,
    readOnly,
    handchange,
    handleBlur,
    errors,
    values,
    vari,
    name,
  } = props;
  console.log(values[name]);
  return (
    <div className="field_item">
      <label className="f4">
        {label} {!notRequire ? <span>*</span> : ""}
      </label>
      <Autocomplete
        multiple
        className="custom_autocomplete"
        readOnly={readOnly}
        value={
          pageOption.length != 0
            ? pageOption.filter((e: any) => {
                return e.value === values[name];
              }).length != 0
              ? pageOption.filter((e: any) => {
                  return e.value === values[name];
                })[0].label
              : values[name]
            : values[name]
        }
        onChange={(e, value: any) => {
          vari(value);
        }}
        options={pageOption}
        renderOption={(
          props: React.HTMLAttributes<HTMLLIElement>,
          option: Partial<any>
        ) => {
          return (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            onBlur={handleBlur}
            error={touched[name] && errors[name] ? true : false}
            helperText={touched[name] && errors[name] ? errors[name] : ""}
            name={name}
            placeholder="Select Type"
            {...params}
          />
        )}
      />
    </div>
  );
};

export default AutoCompleteMultiple;
